import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { CSVSharingT } from '../components/types';
import { RQAPICallWithData } from 'store/APIClient';

export const GET_CSV_SHARINGS_QUERY_KEY = 'csvSharings';

const useGetCsvSharings = (tableName: string): UseQueryResult<CSVSharingT> => {
    return useQuery({
        queryKey: [GET_CSV_SHARINGS_QUERY_KEY, tableName],

        queryFn: async () => {
            const response = await RQAPICallWithData<CSVSharingT>({
                endpoint: `schema/extension/table/${tableName}/sharings`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
};

export default useGetCsvSharings;
